import { css, html } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../Input/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfSearchInput = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.value = "";
    this.disabled = false;
    this.readonly = false;
    this.dsf_error = false;
    this.dsf_success = false;
    this.dsf_size = "medium";
    this.dsf_loading = false;
  }
  handleClearIconClick() {
    this.value = "";
    this.emit({ name: "input", payload: this.value });
  }
  handleInput(ev) {
    this.value = ev.detail;
  }
  render() {
    const iconRight = this.dsf_loading ? "Loader2" : this.value && this.value.length > 0 ? "X" : void 0;
    return html`
      <dsf-input
        class="flex-auto"
        .value=${this.value}
        .disabled=${this.disabled}
        .readonly=${this.readonly}
        .autofocus=${this.autofocus}
        .dsf_error=${this.dsf_error}
        .dsf_success=${this.dsf_success}
        .dsf_placeholder=${this.dsf_placeholder}
        .dsf_name=${this.dsf_name}
        .dsf_label=${this.dsf_label}
        .dsf_message=${this.dsf_message}
        .dsf_size=${this.dsf_size}
        dsf_type="text"
        dsf_icon_left="Search"
        dsf_icon_right=${ifDefined(iconRight)}
        .dsf_icon_right_clickable=${!this.dsf_loading}
        dsf_icon_right_class=${ifDefined(this.dsf_loading ? "animate-spin" : void 0)}
        @icon-right-click=${this.handleClearIconClick}
        @input=${this.handleInput}
      ></dsf-input>
    `;
  }
};
DsfSearchInput.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: inline-flex;
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfSearchInput.prototype, "value", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSearchInput.prototype, "disabled", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSearchInput.prototype, "readonly", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSearchInput.prototype, "dsf_error", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSearchInput.prototype, "dsf_success", 2);
__decorateClass([
  prop({ type: String })
], DsfSearchInput.prototype, "dsf_placeholder", 2);
__decorateClass([
  prop({ type: String })
], DsfSearchInput.prototype, "dsf_name", 2);
__decorateClass([
  prop({ type: String })
], DsfSearchInput.prototype, "dsf_label", 2);
__decorateClass([
  prop({ type: String })
], DsfSearchInput.prototype, "dsf_message", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfSearchInput.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSearchInput.prototype, "dsf_loading", 2);
DsfSearchInput = __decorateClass([
  defineElement("dsf-search-input")
], DsfSearchInput);
export {
  DsfSearchInput
};
